<template src="./App.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";
import WithFilterLayout from "./layouts/WithFilterLayout";
import ExternalLayout from "./layouts/ExternalLayout";
import NotificationSnackbar from "./components/NotificationSnackbar";
import store from "@/store";
import { AccountActions } from "./store/modules/account/actions";
import { notificationsModule } from "./store/modules/notifications";
import { NotificationsActions } from "./store/modules/notifications/actions";
import { AxiosError } from "axios";
import LockedResult from "@/models/LockedResult";

export default defineComponent({
    components: {
        MainLayout,
        AuthLayout,
        WithFilterLayout,
        ExternalLayout,
        NotificationSnackbar
    },
    computed: {
        layout(): string {
            return this.$route?.meta?.layout ?? "MainLayout";
        }
    },
    methods: {
        ...notificationsModule.mapActions({
            showError: NotificationsActions.NotifyError
        }),
        captureError(error: unknown) {
            const axiosError = error as AxiosError;

            if (axiosError.isAxiosError) {
                const lockedResult = axiosError.response?.data as
                    | LockedResult
                    | undefined;
                if (lockedResult && lockedResult.isLocked) return false;

                this.showError(axiosError.message);
                return false;
            }

            this.showError("Unknown error");
            return true;
        }
    },
    mounted() {
        try {
            if (
                !this.$route.matched.some(
                    (record) => record.meta.allowAnonymous
                )
            ) {
                store.dispatch("account/" + AccountActions.VerifyLogin);
            }
        } catch (error) {
            this.captureError(error);
        }
    },
    errorCaptured(error: unknown): boolean {
        return this.captureError(error);
    }
});
</script>
